import { render } from "./IconInput.vue?vue&type=template&id=872a1dd2&scoped=true"
import script from "./IconInput.vue?vue&type=script&lang=js"
export * from "./IconInput.vue?vue&type=script&lang=js"

import "./IconInput.vue?vue&type=style&index=0&id=872a1dd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872a1dd2"]])

export default __exports__